/*
 * Project: bellcloud
 * File: packages/types/device/transfer_mode.ts
 * Author: SWAN
 * Created: 2025-07-21 18:10:58
 * Description:
 */

import type { Option } from '../../common/option';

export enum VolFor50LelCh4 {
  US = 0,
  EU = 1,
}

export type VolFor50LelCh4Option = Option<VolFor50LelCh4>;

export const VOL_FOR_50_LEL_CH4_OPTIONS: Record<VolFor50LelCh4, VolFor50LelCh4Option> = {
  [VolFor50LelCh4.US]: {
    value: VolFor50LelCh4.US,
    label: '2.5%VOL(US)',
  },
  [VolFor50LelCh4.EU]: {
    value: VolFor50LelCh4.EU,
    label: '2.2%VOL(EU)',
  },
};
